import { CTAWrapper } from "../CTA";
import { parseClassesIntoHtml } from "../../functions/styling";

export const BannerWithHeader = ({
	headerText,
	imageComponent,
	content = null,
	subtitle,
	isEven,
	ctas,
	postHeaderText,
	formattedSectionStyles = {},
}) => {
	const CardImageComponent = imageComponent ?? null;

	const BANNER_CLASSES = {
		p: "!text-is2-blue-100 text-base m-0",
		li: "!text-is2-blue-100",
		h4: "!text-white !text-lg mb-0 leading-[32px] !font-medium",
		h3: "!text-xl text-white",
	};

	return (
		<article
			className={`flex flex-col ${formattedSectionStyles?.cardStyling?.backgroundColor || formattedSectionStyles?.inverseColor}`}
		>
			{/* Title and Subtitle - Always at top, centered */}
			<div className={formattedSectionStyles.headerStyling}>
				
				{headerText && <h2 className={`${formattedSectionStyles.textColor} mb-4 font-bold text-center`}>{headerText}</h2>}
				{postHeaderText && (
					<p className="text-base !text-is2-gray-body leading-[24px] !mb-8 text-center">{postHeaderText}</p>
				)}
				<div className="w-full border-t border-is2-blue-100 mb-8 lg:mb-16"></div>
			
				{subtitle && (
					<h3 className={`${formattedSectionStyles.textColor} text-center !text-is2_xl lg:!text-is2_2xl`}>
						{subtitle}
					</h3>
				)}
			</div>

			{/* Image and Content Section */}
			<div
				className={`flex flex-col md:flex-row min-h-[343px] ${isEven ? "md:flex-row-reverse" : ""}`}
			>
				{CardImageComponent && (
					<div className="w-full md:w-1/2 flex items-center justify-center min-h-[343px] relative">
						<div className="absolute inset-0 h-full w-full">{CardImageComponent}</div>
					</div>
				)}
				<div className="flex-1 flex flex-col bg-is2-blue !text-white rounded-b-[32px] md:rounded-l-none md:rounded-r-[32px] px-6 py-8 lg:pl-12 lg:py-16 lg:pr-16 text-left">
					{content && parseClassesIntoHtml(BANNER_CLASSES, content)}
				</div>
			</div>

			{/* CTAs Section - Full width row at bottom */}
			{ctas && ctas.length > 0 && (
				<div className="w-full text-center">
					<div className="flex flex-col w-full md:w-1/2 md:flex-row gap-4 mt-8 lg:mt-16 justify-center m-auto ">
						{ctas.map((cta, index) => (
							<CTAWrapper key={`${cta.title}-${index}`} cta={cta} />
						))}
					</div>
				</div>
			)}
		</article>
	);
};
